module.exports = __webpack_public_path__ + "img/dike_logo.bbccc975.svg";